import { Box, Button, Container, Divider, Typography } from "@mui/material";
import React from "react";
import SwiperCore, { Autoplay, Pagination, EffectCoverflow } from "swiper";
import { Swiper, SwiperSlide } from "swiper/react";
import "swiper/swiper-bundle.min.css";
import "swiper/swiper.min.css";
import "./Gallery.css";
import PropagateLoader from "react-spinners/PropagateLoader";
import { useAPI } from "../../../../apiContext";
import MoreLinks from "../MoreLinks/MoreLinks";
SwiperCore.use([EffectCoverflow, Autoplay, Pagination]);


const Gallery = () => {
	const { data } = useAPI();
	const [open, setOpen] = React.useState(false);

	return (
		<Container sx={{ pt: 5, "& .swiper-slide": { height: "auto" } }}>
			<Box
				sx={{ border: "3px solid", borderRadius: "15px", p: 1 }}
				className='borderColor'>
				{data?._id && data?.headline?.gallery ? (
					<>
						{data?.headline?.gallery === "off" ? (
							""
						) : (
							<>
								<Typography
									className='textColor'
									sx={{ mb: 0.5, fontWeight: 900 }}
									variant='h4'
									component='div'
									gutterBottom>
									{data?.headline?.gallery}
									<Divider className={`${data?.color?.hr}`} />
								</Typography>
								{data?.gallery?.length > 0 ? (
									<Swiper
										effect={"coverflow"}
										autoHeight={true}
										grabCursor={true}
										loop={true}
										autoplay={{ delay: 2500 }}
										centeredSlides={true}
										slidesPerView={"auto"}
										initialSlide={1}
										coverflowEffect={{
											rotate: 50,
											stretch: 0,
											depth: 100,
											modifier: 1,
											slideShadows: false,
										}}
										pagination={true}>
										{data?.gallery?.map((a, key) => (
											<SwiperSlide key={key}>
												<img src={a?.imageLink2} alt='' />
												<Typography
													className='textColor'
													sx={{ fontWeight: 900, mt: 0.5, mb: -2 }}
													variant='h5'
													component='div'>
													{a?.galleryTitle}
												</Typography>
											</SwiperSlide>
										))}
									</Swiper>
								) : (
									<Typography
										className='textColor'
										sx={{ mb: 0.5, fontWeight: 900 }}
										variant='h6'
										component='div'
										gutterBottom>
										No Photos !...
									</Typography>
								)}
							</>
						)}
						<Button
							onClick={() => setOpen(true)}
							className='button'
							variant='contained'
							sx={{
								width: "100%",
								fontWeight: "bold",
								borderRadius: "11px",
								border: "1px solid",
							}}>
							Schedule a Consultation
						</Button>
					</>
				) : (
					<div className='loader'>
						<PropagateLoader size={11} />
					</div>
				)}
			</Box>
			{open && <MoreLinks open={open} setOpen={setOpen} />}
		</Container>
	);
};

export default Gallery;
